var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-treeselect__value-container"},[(_vm.instance.hasValue && !_vm.instance.searchQuery)?_c('div',{staticClass:"vue-treeselect__single-value"},[_vm._v("\n    "+_vm._s(_vm.instance.selectedNodes[0].label)+"\n  ")]):(!_vm.instance.searchQuery)?_c('placeholder'):_vm._e(),_vm._v(" "),_c('search-input',{key:"input",ref:"input"})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/tree-select/SingleValue.vue